module.exports = __webpack_public_path__ + "img/image1.b628f100.png";